import { AdminPageContent } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { ClausesTable } from "./components/clauses-table/ClausesTable";

/**
 * Page displaying list of clauses for admin
 */
const AdminClauses = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Clauses");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Clauses" },
        ]);
    });

    return (
        <AdminPageContent>
            <ClausesTable />
        </AdminPageContent>
    );
};

export default AdminClauses;
